const sendAnalitics = (mouseEvent) => {
    const element = mouseEvent.currentTarget
    const label = element.getAttribute('data-event')
    console.log(label)
    if (typeof ym !== 'undefined') ym(94708217, 'reachGoal', label);
}

const initEvents = () => {
    const elements = document.querySelectorAll('[data-event]')
    elements.forEach(item => item.addEventListener('click', sendAnalitics))
}

initEvents()